import { PhonePlanPrice } from '@app/catalog/products/interface/context';

import { EquipementBase } from '../equipement';

/**
 * Accessory class
 */
export class AccessoryBase extends EquipementBase {
    /**
     * The price with the current context
     */
    public price: number;
    public specialOldPrice: number;
    public type_id: string = 'accessory';

    /**
     * All plans prices
     */
    public plans_prices: PhonePlanPrice[];

    /**
     * to update the prices of phone : plan's prices, price
     */
    protected updatePrice(): void {
        this.price = this.selectPrice();
        const rsf = false;
        let refund: number = this.price;
        let oldRefund: number = 0;
        let total: number = 0;
        if (!this.odr && !rsf) {
            return;
        } else {
            this.odrRsf = {};
        }
        if (this.odr) {
            refund = refund - this.odr.amount;
            oldRefund = this.oldPrice - this.odr.amount;
            oldRefund = oldRefund > 0 ? oldRefund : 1;
            total = Number(this.odr.amount);
            this.odrRsf.odr = this.odr;
        }
        if (refund < 0) {
            this.odrRsf.total = total + refund - 1;
        } else {
            this.odrRsf.total = total;
        }
        refund = refund > 0 ? refund : 1;

        this.odrRsf.refund = refund;
        this.odrRsf.oldRefund = oldRefund;
    }

    private selectPrice(): number {
        if (!this.prices && !this.specialPrice) {
            return 0;
        }
        if (this.specialPrice) {
            this.specialOldPrice = this.prices.sowo.base_price;
        }
        const currentPrice: string = this.specialPrice || this.prices.sowo.base_price;
        return Number.parseFloat(currentPrice);
    }
}
